import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles, Paper } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    zIndex: 2,
    left: 0,
    right: 0
  }
}))

const Menu = props => {
  const classes = useStyles()

  return (
    <Paper square className={classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

Menu.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object
}

export default Menu
